import { uhsome, ic, quantox, brightmarbles, capaciteam } from '../assets';

export const circlePosition = [
  'left-[243px]',
  'left-[182px]',
  'left-[117px]',
  'left-[52px]',
  '-left-[13px]',
];

export const companies = [
  {
    logo: capaciteam,
    name: 'Capaciteam',
    position: 'Software Engineer',
    duration: 'Present',
    color: '#10818f',
    desc: 'Engineered high-performance frontends with Next.js and integrated WordPress via WPGraphQL for scalable web solutions.',
    styles: {
      divStyle: 'hover:border-[#10818f] dark:hover:border-[#10818f]',
      textStyle: 'group-hover:text-[#10818f]',
    },
  },
  {
    logo: brightmarbles,
    name: 'BrightMarbles',
    position: 'Software Engineer',
    duration: '6 Months Experience',
    color: '#2ac5f4',
    desc: 'I had the opportunity to work on a blockchain-based application that utilized cutting-edge technologies to create an innovative platform.',
    styles: {
      divStyle: 'hover:border-[#2ac5f4] dark:hover:border-[#2ac5f4]',
      textStyle: 'group-hover:text-[#2ac5f4]',
    },
  },
  {
    logo: quantox,
    name: 'Quantox Technology',
    position: 'Frontend Developer',
    duration: '1 Year Experience',
    color: '#97C93D',
    desc: "I've worked on a diverse range of apps that serve different audiences, designed for entertainment purposes, using quite a few different technologies.",
    styles: {
      divStyle: 'hover:border-[#97C93D] dark:hover:border-[#97C93D]',
      textStyle: 'group-hover:text-[#97C93D]',
    },
  },
  {
    logo: ic,
    name: 'Innovation Cloud',
    position: 'Frontend Developer',
    duration: '1 Year Experience',
    color: '#55C6CE',
    desc: 'I worked on software that provides the necessary transparency and structure to effectively manage the entire process of developing new products and services.',
    styles: {
      divStyle: 'hover:border-[#55C6CE] dark:hover:border-[#55C6CE]',
      textStyle: 'group-hover:text-[#55C6CE]',
    },
  },
  {
    logo: uhsome,
    name: 'Uhsome',
    position: 'WordPress Developer',
    duration: '2 Years Experience',
    color: '#1F466E',
    desc: 'I have worked on over 30 WordPress websites using custom child themes and various plugins and converting Photoshop designs into responsive WordPress themes.',
    styles: {
      divStyle: 'hover:border-[#1F466E] dark:hover:border-[#1F466E]',
      textStyle: 'group-hover:text-[#1F466E]',
    },
  },
];
